import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/analytics")({
  component: lazyRouteComponent(() => import("./-pages/admin.analytics")),
  head: () => ({
    meta: [
      { title: "التحليلات · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
